module.exports = "/_next/static/images/ThePayoff-xs-35fad3c609d239453e3ad378d431847d.png";